import useService from './useService';
import { useCallback, useEffect } from 'react';
import { redirect } from '../lib/Utils';
import { PersonalizedLogin } from '../lib/services/login';

/**
 * ProxyAuthWithWebToken hook
 * @param props
 */
export default function(props: {
  webToken: string;
  internalUrl: string;
  resend?: number;
}) {
  const { send, success, response } = useService(
    useCallback(() => PersonalizedLogin(props.webToken, props.internalUrl), [
      props.webToken,
      props.internalUrl
    ])
  );
  const isLogged = success;

  useEffect(() => {
    // auth proxy mode - redirect for url from backend if user already log in
    if (isLogged && response && response.body) {
      redirect(response.body ? response.body.url : '/');
    }
  }, [isLogged, response]);

  useEffect(() => {
    send();
  }, [send, props.resend]);

  return {
    isLogged,
    response,
    send
  };
}
